import { useTranslation } from 'react-i18next';

/**
 * Чего стоит действие в TON.
 *
 * Человек видит в кошельке цифру и не понимает, за что она: комиссия сети в
 * TON — копейки, а просят у него в разы больше. Разница в том, что почти всё
 * это не плата, а запас контракта и газ на пересылку, и он возвращается.
 * Молчать об этом — значит оставлять человека гадать ровно в тот момент,
 * когда он решает, подтверждать ли перевод.
 */
export function GasNote({ kind }: { kind: 'pay' | 'create' | 'lock' }) {
  const { t } = useTranslation();
  return (
    <div className="card col" style={{ gap: 6, background: 'var(--sf2)', borderColor: 'transparent' }}>
      <div className="label">{t('gas.title')}</div>
      <span className="text">{t(`gas.${kind}`)}</span>
      {kind !== 'pay' && <span className="muted" style={{ fontSize: 12 }}>{t('gas.refund')}</span>}
      <span className="muted" style={{ fontSize: 12 }}>{t('gas.simple')}</span>
    </div>
  );
}
